var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { List } from 'react-admin';
import { ListLiveUpdate } from './ListLiveUpdate';
/**
 * `<List>` equivalent, but with real-time updates.
 *
 * Shows a event and refreshes the page when a record is created,
 * updated, or deleted.
 *
 * @example
 * ```tsx
 * import { ListLive } from '@react-admin/ra-realtime';
 *
 * const PostList = () => (
 *     <ListLive>
 *         <Datagrid>
 *             <TextField source="title" />
 *         </Datagrid>
 *     </ListLive>
 * );
 * ```
 *
 * @example <caption>With custom side effect on new event</caption>
 * ```tsx
 * import { useRefresh } from 'react-admin';
 * import { ListLive } from '@react-admin/ra-realtime';
 *
 * const PostList = () => {
 *     const refresh = useRefresh();
 *
 *     const handleListEventReceived = (event) => {
 *         refresh();
 *     };
 *
 *     return (
 *         <ListLive onEventReceived={handleListEventReceived}>
 *             <Datagrid>
 *                 <TextField source="title" />
 *             </Datagrid>
 *         </ListLive>
 *     );
 * };
 * ```
 */
export var ListLive = function (_a) {
    var onEventReceived = _a.onEventReceived, children = _a.children, props = __rest(_a, ["onEventReceived", "children"]);
    return (_jsx(List, __assign({}, props, { children: _jsxs(_Fragment, { children: [children, _jsx(ListLiveUpdate, { onEventReceived: onEventReceived })] }) })));
};
/**
 * @deprecated use `<ListLive>` instead
 */
export var RealTimeList = ListLive;
